import React from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import moment from 'moment';

import { getEmailLogged } from '~/auth';

import App from './views/App';
import ErrorBoundary from './views/ErrorBoundary';

import 'moment/locale/pt-br';

moment().locale('pt-br');

const RELEASE = process.env.REACT_APP_SENTRY_RELEASE;

if (process.env.NODE_ENV === 'production' && RELEASE) {
  Sentry.init({
    dsn: 'https://80631c6ebadc4744be731b113cb9aad5@o443341.ingest.sentry.io/5416900',
    release: RELEASE,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  Sentry.configureScope((scope) => {
    scope.setUser({
      email: getEmailLogged(),
    });
  });
}

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorBoundary reset={resetError} />}>
    <App />
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);
